import moment from 'moment-timezone';
import { removeCpfFormatting } from 'utils/formatters';
import { PeriodFilterValuesEnum } from 'utils/periodEnum';
import { FiltersType } from 'v3/data/store/contracting/types';
import { CustomFilterType } from 'v3/shared/components/Filters/MainFilters/types';

export const toDateOnly = (v: any) =>
  v ? (moment.isMoment(v) ? v.clone() : moment.parseZone(String(v))).format('YYYY-MM-DD') : undefined;

export const filterRequestFactory = (form: CustomFilterType, state: FiltersType) => {
  const hasPeriod = form?.period?.isNotEmpty;
  const range = getDateRange(hasPeriod ? form.period : state.period);

  const startDate = toDateOnly(form.startDate ?? range.startDate);
  const finalDate = toDateOnly(form.finalDate ?? range.finalDate);

  const start = startDate ? new Date(startDate) : undefined;
  const final = finalDate ? new Date(finalDate) : undefined;
  start?.setUTCHours(0, 0, 0, 0);
  final?.setUTCHours(23, 59, 59, 999);

  const filters = {
    ...state,
    status: form.status,
    searchString: removeCpfFormatting(form.searchString) || form.searchString,
    startDate: start,
    finalDate: final,
  };

  return removeEmptyProperties(filters);
};

const removeEmptyProperties = (filters) => Object.fromEntries(Object.entries(filters).filter(([key, value]) => value));

export const getDateRange = (
  option: keyof typeof PeriodFilterValuesEnum | '' | undefined
) => {
  const now = moment();

  if (!option) {
    return {
      startDate: undefined,
      finalDate: undefined,
    };
  }

  return {
    startDate: now.clone().startOf(option).format('YYYY-MM-DD'),
    finalDate: now.format('YYYY-MM-DD'),
  };
};
